import { useEffect, useState } from "react";
import { API } from "../../../services/api";
import { EMPTY_PHARMACY_FORM } from "../superAdminRules";

export function usePharmacies() {
    const [pharmacies, setPharmacies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPharmacies = async () => {
            try {
                const { data } = await API.get("/super-admin/pharmacies");
                setPharmacies(data);
            } catch {
                setError("Impossible de charger les pharmacies.");
            } finally {
                setLoading(false);
            }
        };
        fetchPharmacies();
    }, []);

    const replacePharmacy = (id, data) => setPharmacies(prev => prev.map(p => p.id === id ? data : p));

    const handleToggle = async (id) => {
        try {
            const { data } = await API.patch(`/super-admin/pharmacies/${id}/toggle`);
            replacePharmacy(id, data);
        } catch {
            alert("Erreur lors de la mise à jour.");
        }
    };

    const addPharmacy = data => setPharmacies(prev => [...prev, data]);

    return { pharmacies, loading, error, handleToggle, addPharmacy, replacePharmacy };
}

export function usePharmacyCreation(onCreated) {
    const [form, setForm] = useState(EMPTY_PHARMACY_FORM);
    const [submitting, setSubmitting] = useState(false);
    const [formError, setFormError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError(null);
        setSubmitting(true);
        try {
            const { data } = await API.post("/super-admin/pharmacies", form);
            onCreated(data);
            setForm(EMPTY_PHARMACY_FORM);
        } catch (err) {
            setFormError(err.response?.data?.message ?? "Erreur lors de la création.");
        } finally {
            setSubmitting(false);
        }
    };

    return { form, setForm, submitting, formError, handleSubmit };
}
